export default __webpack_public_path__ + "static/media/Lovrican-Logo_2.a3a8d2c0.svg";